import _export from '../internals/export.js';
import stringRepeat from '../internals/string-repeat.js';

var $ = _export;
var repeat = stringRepeat; // `String.prototype.repeat` method
// https://tc39.es/ecma262/#sec-string.prototype.repeat

$({
  target: 'String',
  proto: true
}, {
  repeat: repeat
});
